<template>
  <div class="body">
    <div class="box">
      <span @click="back" class="img">
        <img src="../assets/img/fanhui.png" alt>
      </span>
      <h2 class="title">发票、凭证及退改须知</h2>
    </div>
    <div class="kong"></div>
    <div class="html" v-html="detail.notice"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
        detail:{}
    };
  },
  created() {
      this.init()
  },
  mounted() {},
  methods: {
    back() {
      this.$router.go(-1); //返回上一层
    },
    init() {
      this.$axios
        .post(`api/web/phone/content/detail/${this.$route.query.contentId}`, {})
        .then(res => {
            console.log('res', res)
        this.detail = res.data
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/sass/global.scss";
</style>
<style lang="scss" scoped>
.html {
  padding: 0 18px;
  text-align: left;
  /deep/ img {
    width: 100% !important;
    height: auto;
  }
}
.kong {
    height: 64px;
}
.box {
    background-color: #ededed;
    width: 100%;
    position: fixed;
    padding-bottom: 10px;
    padding-top: 10px;
}
.img {
  position: absolute;
  width: 12px;
  left: 18px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  img {
    width: 100%;
  }
}
.title {
  font-size: 16px;
  color: #232323;
}
.body {
  background: #fff;
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
  overflow: auto;
}
</style>




// WEBPACK FOOTER //
// src/components/detailnotice.vue